const CATEGORIES = {
  productivity: 'pink-800',
  automation: 'green-800',
  programming: 'indigo-800',
  'web-development': 'red-800'
}

export default CATEGORIES
